var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9967_11740)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9967_11740",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0381 0.012085H0.0380859V24.0121H24.0381V0.012085Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9967_11740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03809 20.0121C3.48809 20.0121 3.01709 19.8161 2.62509 19.4241C2.23309 19.0321 2.03743 18.5614 2.03809 18.0121V6.01209C2.03809 5.46209 2.23409 4.99109 2.62609 4.59909C3.01809 4.20709 3.48876 4.01143 4.03809 4.01209H20.0381C20.5881 4.01209 21.0591 4.20809 21.4511 4.60009C21.8431 4.99209 22.0388 5.46276 22.0381 6.01209V11.0121C22.0381 11.5644 21.5904 12.0121 21.0381 12.0121H4.03809V18.0121H15.0381C15.5904 18.0121 16.0381 18.4598 16.0381 19.0121C16.0381 19.5644 15.5904 20.0121 15.0381 20.0121H4.03809ZM4.03809 8.92871H20.0381V6.01209H4.03809V8.92871ZM20.0381 22.0121C19.4858 22.0121 19.0381 21.5644 19.0381 21.0121V19.0121H17.0381C16.4858 19.0121 16.0381 18.5644 16.0381 18.0121C16.0381 17.4598 16.4858 17.0121 17.0381 17.0121H19.0381V15.0121C19.0381 14.4598 19.4858 14.0121 20.0381 14.0121C20.5904 14.0121 21.0381 14.4598 21.0381 15.0121V17.0121H23.0381C23.5904 17.0121 24.0381 17.4598 24.0381 18.0121C24.0381 18.5644 23.5904 19.0121 23.0381 19.0121H21.0381V21.0121C21.0381 21.5644 20.5904 22.0121 20.0381 22.0121Z",
    fill: "#76BC21"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9967_11740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0380859 0.012085)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardAddIcon);
export default __webpack_public_path__ + "static/media/creditCardAddIcon.9f86c8a4fc9431739424c3e2ac523623.svg";
export { ForwardRef as ReactComponent };